import React from 'react'
import { CONTENT_COLLAPSE_WIDTH } from 'lib/layoutConstants'

const collapseByDefault = window.innerWidth <= CONTENT_COLLAPSE_WIDTH

export const ThreePanelCollapseContext = React.createContext(collapseByDefault)

// higher-order function to consume collapse state in a component definition
export const withCollapse = Component => props => (
  <ThreePanelCollapseContext.Consumer>
    {(collapse) => <Component collapse={collapse} {...props} />}
  </ThreePanelCollapseContext.Consumer>
)
